import Stripe from 'stripe';
import { z } from 'zod';

const webBaseSubscription = z.object({
  id: z.string(),
  userId: z.string(),
  bundleId: z.string().optional(),
  status: z.enum(['active', 'inactive']),
  autoRenew: z.boolean(),
  source: z.enum(['revcat', 'lifetime', 'paypal', 'none']),
  lastCacheTimestamp: z.number(),
  expirationDate: z.string(),
});

const webStripeSubscription = webBaseSubscription.extend({
  source: z.enum(['stripe']),
  // Note: for now we only grab the subscription item since we save it to a browser cookie and there's size limitations
  rawStripeSubscription: z.any() as z.ZodType<{
    plan: Stripe.Subscription['items']['data'][0]['plan'];
    /**
     * @deprecated Use `discounts` array instead.
     */
    discount: Stripe.Discount | string | undefined | null;
    discounts: Stripe.Subscription['discounts'];
  }>,
});

export const webSubscriptionSchema = z.discriminatedUnion('source', [webBaseSubscription, webStripeSubscription]);

/**
 * NOTE: This is temporary until we move web to use the entitlements endpoint
 * from `saturn` which will be the ultimately single source of truth for user entitlements.
 */
export type WebSubscription = z.infer<typeof webSubscriptionSchema>;
